// import axios from 'axios'
import buildType from '../../../services/buildType'
// import router from '../../../router/index'
export default {
  state: {
    urlQuery: null,
    esanqua: buildType.apiURL('esanqua'),
    selectedPayreqList: null,
    payreqQueueIndex: 0,

    paybillUrlQuery: null,
    selectedPaybillList: null,
    paybillQueueIndex: 0
  },
  mutations: {
    setPayreqPageQuery(state, payload) {
      state.urlQuery = payload
    },
    setPayreqQueue(state, payload) {
      state.selectedPayreqList = payload.list
      state.payreqQueueIndex = payload.index
    },
    setPaybillPageQuery(state, payload) {
      state.paybillUrlQuery = payload
    },
    setPaybillQueue(state, payload) {
      state.selectedPaybillList = payload.list
      state.paybillQueueIndex = payload.index
    }
  },
  actions: {},
  getters: {
    getPayreqPageQuery(state) {
      return state.urlQuery
    },
    getPayreqList(state) {
      return {
        list: state.selectedPayreqList,
        index: state.payreqQueueIndex
      }
    },
    getPaybillPageQuery(state) {
      return state.paybillUrlQuery
    },
    getPaybillList(state) {
      return {
        list: state.selectedPaybillList,
        index: state.paybillQueueIndex
      }
    }
  }
}
